import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { Card, Table, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Flex from 'components/shared-components/Flex'
import utils from 'utils'
import apiClient from 'services/apiClient';
import { useMyContext } from 'Context/MyContextProvider';
const Groups = forwardRef(({ GetGroupNumber, noCard, hideSearch = false }, ref) => {
    const { api, authToken, UserData } = useMyContext();
    const [list, setList] = useState([])
    const [groupListData, setGroupData] = useState([])
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        const GroupData = async () => {
            setLoading(true)
            try {
                const response = await apiClient.get(`${api}groups/${UserData.id}`, {
                    headers: {
                        Authorization: "Bearer " + authToken,
                    },
                });
                const data = (response.data.groups).reverse();
                setGroupData(data);
                setList(data);
                setLoading(false)
            } catch (error) {
                setLoading(false)
                console.log(error);
            }
        }

        if (UserData && UserData.id) {
            GroupData()
        }
    }, [api, authToken, UserData])

    useImperativeHandle(ref, () => ({
        resetSelection: () => {
            setSelectedRowKeys([]); // Clear the selection
        },
        onSearch: (value) => {
            const data = utils.wildCardSearch(groupListData, value)
            setList(data)
            setSelectedRowKeys([])
        }
    }));



    const tableColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
            sorter: (a, b) => utils.antdTableSorter(a, b, 'name')
        },
        {
            title: 'Description',
            dataIndex: 'description',
            sorter: (a, b) => utils.antdTableSorter(a, b, 'description')
        },
        {
            title: 'Total Contacts',
            dataIndex: 'contacts_count',
            sorter: (a, b) => utils.antdTableSorter(a, b, 'contacts_count')
        },
    ];

    const rowSelection = {
        onChange: (key) => {
            setSelectedRowKeys(key)
        }
    };

    const onSearch = e => {
        const value = e.currentTarget.value
        const data = utils.wildCardSearch(groupListData, value)
        setList(data)
        setSelectedRowKeys([])
    }

    useEffect(() => {
        if (selectedRowKeys) {
            const selectedGroups = groupListData.filter(group => selectedRowKeys.includes(group.id));
            const contacts = selectedGroups.flatMap(group => group.contacts?.map(contact => contact.number));
            GetGroupNumber(contacts, selectedGroups.length, contacts.length);
        }
    }, [selectedRowKeys, GetGroupNumber, groupListData]);

    const content = (
        <>
            {!hideSearch && (
                <Flex alignItems="center" justifyContent="space-between" mobileFlex={false}>
                    <Flex className="mb-1" mobileFlex={false}>
                        <div className="mr-md-3 mb-3" style={noCard ? { width: '100%', padding: '0 16px' } : undefined}>
                            <Input placeholder="Search" prefix={<SearchOutlined />} onChange={e => onSearch(e)} />
                        </div>
                    </Flex>
                </Flex>
            )}
            <div className="table-responsive" style={noCard ? { padding: '0 16px' } : undefined}>
                <Table
                    loading={loading}
                    columns={tableColumns}
                    dataSource={list}
                    rowKey='id'
                    rowSelection={{
                        selectedRowKeys: selectedRowKeys,
                        type: 'checkbox',
                        preserveSelectedRowKeys: false,
                        ...rowSelection,
                    }}
                />
            </div>
        </>
    );

    return noCard ? content : <Card title="Contact Groups">{content}</Card>;
});

export default Groups
